import {
    defaultMethodResource,
    useMethodActions,
} from '../../../../resource/resources/artifacts/method/methodResource';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { OpenModal } from '../../../../../../react-commons/utils/modals/openModal';
import {
    defaultProcessAreaMethodAssociationResource,
    useProcessAreaMethodAssociationActions,
} from '../../../../resource/resources/artifacts/process_area/processAreaMethodAssociationResource';
import { StackedCardsComponent } from '../../../reusable-components/StackedCardsComponent';
import { useDeleteResourceDialogFunction } from '../../../reusable-components/dialogs/UseDeleteResourceDialogFunction';
import React from 'react';
import { MethodEditDialog } from '../../project/reusable-elements/method/MethodEditDialog';
import { useNestedDialogFunction } from '../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';

export const StackedMethodsView = ({isAdmin, processAreaId, versionId, link}: {
    isAdmin: boolean,
    processAreaId: string | undefined,
    versionId: string | undefined,
    link: string | undefined
}) => {

    const nestedDialog = useNestedDialogFunction();
    const deleteResourceDialogFunction = useDeleteResourceDialogFunction();

    const methodAssociationActions = useProcessAreaMethodAssociationActions();
    const methodActions = useMethodActions();
    const methodAssociationsQuery = methodAssociationActions.useGetAllResources(processAreaId)
    const methodsQuery = methodActions.useGetAllResources(versionId);

    const deleteMethodAssociation = methodAssociationActions.useDeleteResource();
    const addMethodAssociation = methodAssociationActions.useAddResource();
    const addMethod = methodActions.useAddResource();
    const addAssociation = () => OpenModal.SelectionOrCreateModal(
        "Select or Create a Method",
        methodsQuery.data?.filter(method =>
            !(methodAssociationsQuery.data
                ?.some(association => association.method === method.objectId)))
            .map(method => ({label: method.name, value: method.objectId})) ?? [],
        true,
        null,
        async (value) => {
            if (value && processAreaId) {
                await addMethodAssociation.mutateAsync({
                    resource: {
                        ...defaultProcessAreaMethodAssociationResource,
                        method: value
                    },
                    parentId: processAreaId
                })
            }
        },
        async (value, multiLineValue) => {
            if (value && processAreaId && versionId) {
                await addMethod.mutateAsync({
                        resource: {
                            ...defaultMethodResource,
                            name: value,
                            description: multiLineValue ?? ""
                        },
                        parentId: versionId
                    },
                    {
                        onSuccess: (result) => {
                            const methodObjectId = result?.content?.objectId
                            if (methodObjectId) {
                                addMethodAssociation.mutateAsync({
                                    resource: {
                                        ...defaultProcessAreaMethodAssociationResource,
                                        method: methodObjectId
                                    },
                                    parentId: processAreaId
                                })
                            }
                        },
                    }
                )
            }
        },
        undefined,
        "Name",
        true,
        "Description",
        800
    )

    const onDelete = (id: string) => {
        deleteResourceDialogFunction.deleteResource(
            id, null, ResourceType.PROCESS_AREA_METHOD_ASSOCIATION, deleteMethodAssociation
        )
    }

    const onEdit = (id: string) => {
        const association = methodAssociationsQuery.data?.find(value => value.id === id)
        if (association) {
            nestedDialog.showNestedDialog(
                <MethodEditDialog
                    onClose={nestedDialog.closeNestedDialog}
                    objectId={association.method}
                    versionedInId={versionId ?? ""}
                />
            );
        }
    }

    return (
        <StackedCardsComponent
            title={"Methods"}
            data={methodAssociationsQuery.data?.map(value => ({
                id: value.id,
                text: methodsQuery.data?.find(resource => resource.objectId === value.method)?.name ?? "",
                description: methodsQuery.data?.find(resource => resource.objectId === value.method)?.description ?? "",
                img: null
            })) ?? []}
            onAdd={isAdmin ? addAssociation : undefined}
            onDelete={isAdmin ? onDelete : undefined}
            onEdit={isAdmin ? onEdit : undefined}
            link={link}
            section={"methods"}
        />
    );
};